const config = {
    API_URL: 'https://dev-mon-ismo.siqual.net/api/',
};

export default config;
